import React, { useEffect, useState } from 'react';
import { useAuth } from 'hooks';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Alert, Loader, Header, Layout } from 'components';
import { CssBaseline } from '@mui/material';
import { muiTheme } from 'theme';
import Routes from 'routes';
import { AppProvider } from 'context';
import { HeaderProvider } from 'context/HeaderContext';

const theme = createTheme({
	palette: {
		...muiTheme.palette
	},
	typography: muiTheme.typography,
	components: {
		...muiTheme.components,
		MuiCssBaseline: {
			styleOverrides: {
				body: {
					backgroundColor: muiTheme.palette.background.default,
					color: muiTheme.palette.text.primary
				}
			}
		}
	},
	spacing: muiTheme.spacing,
	shape: muiTheme.shape,
	zIndex: muiTheme.zIndex,
	breakpoints: muiTheme.breakpoints
});

const App = (props) => {
	const { authenticateFromToken, fetchMe } = useAuth();
	const [drawerOpen, setDrawerOpen] = useState(false);

	const handleToggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};

	useEffect(() => {
		const initializeAuth = async () => {
			const token = localStorage.getItem('token');
			if (token) {
				authenticateFromToken(token);
				await fetchMe(); // Fetch user data after token is set
			}
		};

		initializeAuth();
	}, []); // Remove authenticateFromToken from deps to prevent re-runs

	return (
		<AppProvider>
			<HeaderProvider>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<Alert />
					<Header open={drawerOpen} toggleMenu={handleToggleDrawer} />
					<Layout>
						<Routes {...props} />
					</Layout>
					<Loader />
				</ThemeProvider>
			</HeaderProvider>
		</AppProvider>
	);
};

export default App;
